"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    onClick: function () {
        /* do nothing */
    },
    disabled: false,
    variant: 'inline',
};
exports.default = defaultProps;
//# sourceMappingURL=defaultProps.js.map